export enum ModuleEnum {
  allModules = 'allModules',
  feedback = 'feedback',
  conversations = 'conversations',
  motivation = 'motivation',
  interviews = 'interviews',
  salesAndServices = 'sales',
  sales = 'sales',
  health_dialogues = 'dialogues',
  dialogues = 'dialogues',
  demo = 'demo',
  telefonica = 'telefonica',
  customer = 'customer',
  universitas = 'universitas',
  feedbackCircet = 'feedback-circet',
  testModule = 'test-module',
  christmasSimskills ='navidad-simskills',
  cadiz ='cadiz',
  performance = 'performance',
  impactinterviews = 'impact-interviews',
  asisaTraining = 'asisa_training'
}
